module.exports = __webpack_public_path__ + "images/emoji/neckbeard.dfe3a059aaf306af47c1.png";